import {Injectable} from '@angular/core';
import {FormDataUpload, NestApiProvider} from '../../nest-api';
import {RequestTypeDto, ResponseTypeDto} from '../dto/new-activity.dto';
import {Observable} from 'rxjs';

@Injectable()
export class NewActivityApi {
  private service: string = '';
  private model: string = 'newActivity';

  constructor(
      private nestApiProvider: NestApiProvider
  ) {
  }

  type(payload: RequestTypeDto): Observable<ResponseTypeDto> {
    const method: string = 'GET';
    const func: string = 'type';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof payload.limit !== 'undefined' && payload.limit !== null) urlParams.limit = payload.limit;
    if (typeof payload.page !== 'undefined' && payload.page !== null) urlParams.page = payload.page;
    if (typeof payload.filter !== 'undefined' && payload.filter !== null) urlParams.filter = payload.filter;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseTypeDto>(method, url, func, params, body);
  }


  detail(data: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'type/detail';
    const params: any = {};
    const urlParams: any = data;
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  downloadTemplate(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'downloadTemplate';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob<any>(method, url, func, params, body);
  }

  uploadTemplate(formData: FormDataUpload[]): Observable<any> {
    const method: string = 'POST';
    const func: string = 'uploadTemplate';
    const params: any = {};
    const urlParams: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestUpload<any>(method, url, formData);
  }


}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/new-activity.api.ts